import { BaseModel } from "../base/base.model";
import { mapper } from "src/app/infrastructure/infrastructure-services/common/mapper";
import { AutoMap } from "@automapper/classes";
import {createMap, forMember, mapFrom, mapWith,} from '@automapper/core';
import { audit } from "rxjs";



 export interface IEwbTransporter_Lines_List
 {
    mode:string;
    modeName: string;
    vehicleTypeName:string;
    vehicleType: string;
    vehicleNo : string;
    lineNumber:number;
    flag:boolean
 }

 export class EwbTransporter_Lines_List implements IEwbTransporter_Lines_List
 {
   @AutoMap() mode:string="";
   @AutoMap() modeName: string="";
   @AutoMap() vehicleTypeName:string="";
   @AutoMap() vehicleType: string="";
   @AutoMap() vehicleNo : string="";
   @AutoMap() lineNumber!:number;
   @AutoMap() flag!:boolean
   constructor()
   {
      createMap(mapper,EwbTransporter_Lines_List,EwbTransporter_Lines_ListSAP,
      forMember(
         (destination) => (destination.Mode),
         mapFrom((source) => (source.mode))
      ),
      forMember(
         (destination) => (destination.VehicleType),
         mapFrom((source) => (source.vehicleType))
      ),
      forMember(
         (destination) => (destination.VehicleNo),
         mapFrom((source) => (source.vehicleNo))
      ),
      forMember(
         (destination) => (destination.LineNumber),
         mapFrom((source) => (source.lineNumber))
      )
      )
   }
 }


 export interface IEwbTransporter_Lines_ListSAP
 {
    Mode: string;
    VehicleType: string;
    VehicleNo : string;
    LineNumber:number;
 }

 export class EwbTransporter_Lines_ListSAP implements IEwbTransporter_Lines_ListSAP
 {
   @AutoMap() Mode: string="";
   @AutoMap() VehicleType: string="";
   @AutoMap() VehicleNo : string="";
   @AutoMap() LineNumber!:number;
   constructor()
   {
      createMap(mapper,EwbTransporter_Lines_List,EwbTransporter_Lines_ListSAP,
      forMember(
         (destination) => (destination.Mode),
         mapFrom((source) => (source.modeName))
      ),
      forMember(
         (destination) => (destination.VehicleType),
         mapFrom((source) => (source.vehicleType))
      ),
      forMember(
         (destination) => (destination.VehicleNo),
         mapFrom((source) => (source.vehicleNo))
      ),
      forMember(
         (destination) => (destination.LineNumber),
         mapFrom((source) => (source.lineNumber))
      )
      )
   }
}

export interface ITransporterMasterModel extends BaseModel {
   absEntry: number,
   transporterCode : string,
   transporterName:string;
   transporterID:string;
   ewbTransporter_Lines:IEwbTransporter_Lines_List[];
   
}

 export class TransporterMasterModel implements ITransporterMasterModel {
    @AutoMap() absEntry! :number;
    @AutoMap() transporterCode:string="";
    @AutoMap() transporterName :string="";
    @AutoMap() transporterID:string="";
   // @AutoMap() ewbTransporter_Lines:IEwbTransporter_Lines_List[]=[];
    @AutoMap(() => EwbTransporter_Lines_List) ewbTransporter_Lines: EwbTransporter_Lines_List[] = [];
   
 }


 export interface ITransporterMasterModelSAP extends BaseModel {
    AbsEntry: number;
    TransporterCode : string;
    TransporterName:string;
    TransporterID:string;
    EWBTransporter_Lines:IEwbTransporter_Lines_ListSAP[];
 }
 
 export class TransporterMasterModelSAP implements ITransporterMasterModelSAP {
    @AutoMap() AbsEntry !:number;
    @AutoMap() TransporterCode:string="";
    @AutoMap() TransporterName :string="";
    @AutoMap() TransporterID:string="";
  //  @AutoMap() EWBTransporter_Lines:IEwbTransporter_Lines_ListSAP[]=[];
    @AutoMap(() => EwbTransporter_Lines_ListSAP) EWBTransporter_Lines: EwbTransporter_Lines_ListSAP[] = [];
    constructor()
     {
        createMap(mapper,TransporterMasterModel,TransporterMasterModelSAP,
         forMember(
             (destination) => (destination.AbsEntry),
             mapFrom((source) => (source.absEntry))
         ),
         forMember(
            (destination) => (destination.TransporterCode),
             mapFrom((source) => (source.transporterCode))
         ),
         forMember(
            (destination) => (destination.TransporterName),
             mapFrom((source) => (source.transporterName))
         ),
         forMember(
            (destination) => (destination.TransporterID),
             mapFrom((source) => (source.transporterID))
         ),
         forMember(
            (destination) => (destination.EWBTransporter_Lines),
             mapWith(EwbTransporter_Lines_ListSAP,EwbTransporter_Lines_List,(source)=>source.ewbTransporter_Lines)
         ),
        )
     }
   }
 


